import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';

export const CompensationUnit = z.enum(['hourly', 'salary']);

export type CompensationUnit = z.infer<typeof CompensationUnit>;

export const CompensationUnits = Object.values(CompensationUnit.Values);

export const PayBenchmarkingInputs = z.object({
  dropdowns: z.object({
    benchmark: z.array(z.string()),
    department: z.array(z.string()),
    job_title: z.array(z.string()),
    job_level: z.array(z.string()),
    location: z.array(z.string()),
    experience: z.array(z.string()),
    education: z.array(z.string()),
    compensation_unit: z.array(CompensationUnit),
    currency: z.array(z.string()),
  }),
  extras: EmptyObject,
});

export const PayBenchmarkingRequest = createCustomVizRequestSchema(
  'payBenchmarking',
  PayBenchmarkingInputs,
);

export type PayBenchmarkingRequest = z.infer<typeof PayBenchmarkingRequest>;
